// extracted by mini-css-extract-plugin
export default {"container":"waterfall_container__ISZtQ","originCard":"waterfall_originCard__FJ-9P","left":"waterfall_left__bjBLW","right":"waterfall_right__NTkCa"};